import firebase from "datastore/database";
import store from "datastore/store";

export default function observeBusinesses() {
  store.dispatch({ type: "ADD_BUSINESSES_LOADING" });
  return firebase
    .firestore()
    .collection("businesses")
    .onSnapshot((doc) => {
      const businesses = Object.create(null);
      doc.forEach((item) => {
        let businessItem = item?.data();
        const lng = businessItem.location?.lng;
        const lat = businessItem.location?.lat;
        // to avoid break app when lng or lat === 'Enter'.
        if (lng === "Enter" || lat === "Enter") {
          businessItem = { ...businessItem, location: { lng: 0, lat: 0 } };
        }
        return (businesses[item.id] = businessItem);
      });
      store.dispatch({ type: "ADD_BUSINESSES_SUCCESS", businesses });
    });
}
